import {
    INIT_MEDIA_LIST,
} from 'redux/mediaList/actions'

export const mediaList = (state = [], {type, mediaList}) => {

    switch (type)
    {
        case INIT_MEDIA_LIST:
            return {...mediaList}
        default:
            return state
    }
}
